import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import { IAuroraState } from '@apps/aurora.state';
import { Profile } from '@apps/auth/models';
import { getShortProfile } from '@apps/auth/store/users/users.selectors';

@Component({
    selector: 'aa-detailed-user',
    templateUrl: './detailed-user.component.html',
    styleUrls: [
        './detailed-user.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DetailedUserComponent implements OnInit
{
    @Input() userName: string;
    @Input() titleKeyTrad: string = undefined;
    @Input() iconPosition: 'left'|'right' = 'left';
    public user: Observable<Profile>;
    public src: Observable<string> = of('./assets/images/AurorA.png');

    constructor (
        private store: Store<IAuroraState>
    )
    {}

    ngOnInit ()
    {
        this.user = this.store.select(getShortProfile(this.userName));
    }
}
